<nav aria-label="Primary">
    <mat-list>
        <ul class="sidenav-list">
            @for (item of items(); track item.id) {
                <li class="sidenav-menu">
                    <a
                        mat-list-item
                        [routerLink]="item.route"
                        [routerLinkActive]="item.activeState ? 'active' : ''"
                        [ariaCurrentWhenActive]="item.activeState?.ariaCurrent ?? undefined"
                        (click)="itemActivated.emit()"
                        [routerLinkActiveOptions]="{ exact: item.activeState?.exact ?? true }"
                    >
                        <fa-icon [icon]="item.icon" [fixedWidth]="true"></fa-icon>
                        <span>{{ item.label }}</span>
                    </a>
                    @if (item.children.length) {
                        <ul class="sidenav-submenu">
                            @for (child of item.children; track child.id) {
                                <li class="sidenav-menu sub-menu">
                                    <a
                                        mat-list-item
                                        [routerLink]="child.route"
                                        [routerLinkActive]="child.activeState ? 'active' : ''"
                                        [ariaCurrentWhenActive]="child.activeState?.ariaCurrent ?? undefined"
                                        (click)="itemActivated.emit()"
                                        [routerLinkActiveOptions]="{ exact: child.activeState?.exact ?? true }"
                                    >
                                        <fa-icon [icon]="child.icon" [fixedWidth]="true"></fa-icon>
                                        <span>{{ child.label }}</span>
                                    </a>
                                </li>
                            }
                        </ul>
                    }
                </li>
            }
        </ul>
    </mat-list>
</nav>
